export default function SocialMediaLinksRow({
  color,
  className,
}: {
  color?: string;
  className?: string;
}) {
  return (
    <div className={`flex gap-4 ${className}`}>
      <button
        className="rounded-full hover:bg-white/10"
        onClick={() =>
          window.open("https://www.facebook.com/SFMTA.Muni", "_blank")
        }
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className={color ?? "fill-primary"}
            d="M31.8333 16C31.8333 7.25999 24.74 0.166656 16 0.166656C7.25999 0.166656 0.166656 7.25999 0.166656 16C0.166656 23.6633 5.61332 30.0442 12.8333 31.5167V20.75H9.66666V16H12.8333V12.0417C12.8333 8.98582 15.3192 6.49999 18.375 6.49999H22.3333V11.25H19.1667C18.2958 11.25 17.5833 11.9625 17.5833 12.8333V16H22.3333V20.75H17.5833V31.7542C25.5792 30.9625 31.8333 24.2175 31.8333 16Z"
            fill={color}
          />
        </svg>
        <span className="sr-only">SFMTA Facebook</span>
      </button>
      <button
        className="rounded-full hover:bg-white/10"
        onClick={() => window.open("https://twitter.com/sfmta_muni", "_blank")}
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className={color ?? "fill-primary"}
            d="M16 0C24.8457 0 32 7.15429 32 16C32 24.8457 24.8457 32 16 32C7.15429 32 0 24.8457 0 16C0 7.15429 7.15429 0 16 0ZM13.0743 24.4343C20.16 24.4343 24.0457 18.56 24.0457 13.4629V12.96C24.8 12.4114 25.4629 11.7257 25.9657 10.9486C25.28 11.2457 24.5257 11.4514 23.7486 11.5657C24.5486 11.0857 25.1657 10.3314 25.44 9.44C24.6857 9.87429 23.8629 10.1943 22.9943 10.3771C22.2857 9.62286 21.28 9.16572 20.1829 9.16572C18.0571 9.16572 16.32 10.9029 16.32 13.0286C16.32 13.3257 16.3429 13.6229 16.4343 13.8971C13.2343 13.7371 10.3771 12.2057 8.48 9.87429C8.16 10.4457 7.95429 11.1086 7.95429 11.8171C7.95429 13.1429 8.64 14.3314 9.66857 15.0171C9.02857 15.0171 8.43429 14.8343 7.93143 14.5371V14.5829C7.93143 16.4571 9.25714 18.0114 11.0171 18.3771C10.6971 18.4686 10.3543 18.5143 10.0114 18.5143C9.76 18.5143 9.53143 18.4914 9.28 18.4457C9.76 19.9771 11.2 21.0971 12.8686 21.12C11.5429 22.1486 9.87429 22.7657 8.06857 22.7657C7.74857 22.7657 7.45143 22.7657 7.15429 22.72C8.84571 23.8171 10.88 24.4571 13.0514 24.4571"
            fill={color}
          />
        </svg>
        <span className="sr-only">SFMTA Twitter</span>
      </button>
      <button
        className="rounded-full hover:bg-white/10"
        onClick={() =>
          window.open(
            "https://www.linkedin.com/company/san-francisco-municipal-transportation-agency/mycompany/",
            "_blank"
          )
        }
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className={color ?? "fill-primary"}
            d="M16 0.640015C7.5168 0.640015 0.639999 7.51682 0.639999 16C0.639999 24.4832 7.5168 31.36 16 31.36C24.4832 31.36 31.36 24.4832 31.36 16C31.36 7.51682 24.4832 0.640015 16 0.640015ZM12.24 22.3664H9.1296V12.3568H12.24V22.3664ZM10.6656 11.128C9.6832 11.128 9.048 10.432 9.048 9.57121C9.048 8.69281 9.7024 8.01761 10.7056 8.01761C11.7088 8.01761 12.3232 8.69281 12.3424 9.57121C12.3424 10.432 11.7088 11.128 10.6656 11.128ZM23.6 22.3664H20.4896V16.8192C20.4896 15.528 20.0384 14.6512 18.9136 14.6512C18.0544 14.6512 17.544 15.2448 17.3184 15.816C17.2352 16.0192 17.2144 16.3072 17.2144 16.5936V22.3648H14.1024V15.5488C14.1024 14.2992 14.0624 13.2544 14.0208 12.3552H16.7232L16.8656 13.7456H16.928C17.3376 13.0928 18.3408 12.1296 20.0192 12.1296C22.0656 12.1296 23.6 13.5008 23.6 16.448V22.3664Z"
            fill={color}
          />
        </svg>
        <span className="sr-only">SFMTA LinkedIn</span>
      </button>
    </div>
  );
}
